<template>
    <div v-if="issue_obj">
        <div>
            <h5 class="ml-3">Location Details</h5>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <vs-input 
                        :value="issue_obj.data.id ? `Issue #${issue_obj.data.id}` : 'Auto Generated'"
                        label="* Issue ID"
                        readonly
                        class="w-full"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <SelectDate :disabled="mode != 'e'" :selectedDate.sync="issue_obj.data.date_of_accident" label="Date of Accident" />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <label class="vs-input--label block">Direction</label>
                    <div class="flex mt-3 align-center">
                        <vs-radio :disabled="mode != 'e'" v-model="issue_obj.data.direction" vs-name="direction" vs-value="lhs">LHS</vs-radio>
                        <vs-radio :disabled="mode != 'e'" v-model="issue_obj.data.direction" vs-name="direction" vs-value="rhs" class="mx-3">RHS</vs-radio>
                        <vs-radio :disabled="mode != 'e'" v-model="issue_obj.data.direction" vs-name="direction" vs-value="bhs" class="mx-3">BHS</vs-radio>
                        <vs-radio :disabled="mode != 'e'" v-model="issue_obj.data.direction" vs-name="direction" vs-value="median" class="mx-3">Median</vs-radio>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.direction">
                        {{ api_errors.data.direction.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <vs-input
                        v-model="issue_obj.data.accident_location"
                        label="Accident Location"
                        class="w-full"
                        :disabled="mode != 'e'"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.accident_location">
                        {{ api_errors.data.accident_location.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <label class="vs-input--label block">Chainage</label>
                    <vs-row class="mt-1">
                        <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-0 pr-1">
                            <div class="flex" style="align-items: center">
                                <label class="vs-input--label block mr-3">From</label>
                                <vs-input
                                    v-model="issue_obj.data.chainage_from"
                                    class="w-full"
                                    :disabled="mode != 'e'"
                                />
                            </div>
                            <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.chainage_from">
                                {{ api_errors.data.chainage_from.join(', ') }}
                            </small>
                        </vs-col>
                        <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-1 pr-0">
                            <div class="flex" style="align-items: center">
                                <label class="vs-input--label block mr-3">To</label>
                                <vs-input
                                    v-model="issue_obj.data.chainage_to"
                                    class="w-full"
                                    :disabled="mode != 'e'"
                                />
                            </div>
                            <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.chainage_to">
                                {{ api_errors.data.chainage_to.join(', ') }}
                            </small>
                        </vs-col>
                    </vs-row>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <SelectForeign
                        :model.sync="issue_obj.assigned_reviewers"
                        label="Select Incident Manager"
                        placeholder="Type to Search..."
                        :multiple="true"
                        :load_initial="true"
                        :label_keys="['first_name', 'last_name']"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="false"
                        :close_on_select="false"
                        :disabled="mode != 'e'"
                        :use_cache="true"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.assigned_reviewers">
                        {{ api_errors.assigned_reviewers.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
        </div>
        <div>
            <h5 class="ml-3">Time Details</h5>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3" style="margin-left: 0%; width: 100%;">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                        <label for class="vs-input--label">Time of Accident (HH:MM)</label>
                        <div class="vs-con-input">
                            <VueTimepicker auto-scroll v-model="issue_obj.data.time_of_accident" :disabled="mode != 'e'"></VueTimepicker>
                        </div>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.time_of_accident">
                        {{ api_errors.data.time_of_accident.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                        <label for class="vs-input--label">Accident Call Recieved (HH:MM)</label>
                        <div class="vs-con-input">
                            <VueTimepicker auto-scroll v-model="issue_obj.data.accident_call_received_at" :disabled="mode != 'e'"></VueTimepicker>
                        </div>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.accident_call_received_at">
                        {{ api_errors.data.accident_call_received_at.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                        <label for class="vs-input--label">Incident Management Reached Time (HH:MM)</label>
                        <div class="vs-con-input">
                            <VueTimepicker auto-scroll v-model="issue_obj.data.safety_team_reached_at" :disabled="mode != 'e'"></VueTimepicker>
                        </div>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.safety_team_reached_at">
                        {{ api_errors.data.safety_team_reached_at.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                        <label for class="vs-input--label">* Response Time (HH:MM)</label>
                        <div class="vs-con-input">
                            <VueTimepicker auto-scroll :value="response_time" disabled></VueTimepicker>
                        </div>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.response_time">
                        {{ api_errors.data.response_time.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                        <label for class="vs-input--label">Accident Clearence Time (HH:MM)</label>
                        <div class="vs-con-input">
                            <VueTimepicker auto-scroll v-model="issue_obj.data.accident_clearance_time" :disabled="mode != 'e'"></VueTimepicker>
                        </div>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.accident_clearance_time">
                        {{ api_errors.data.accident_clearance_time.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
        </div>
        <div>
            <h5 class="ml-3">Accident Details</h5>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <SelectForeign
                        :model.sync="issue_obj.data.nature_of_accident"
                        label="Nature of Accident"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_nature_of_accidents}?active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="false"
                        :disabled="mode != 'e'"
                        :use_cache="true"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.nature_of_accident">
                        {{ api_errors.data.nature_of_accident.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <SelectForeign
                        :model.sync="issue_obj.data.classification_of_accident"
                        label="Classification of Accident"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_accident_classifications}?accident_type_category=road_user_accident&active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="false"
                        :disabled="mode != 'e'"
                        :use_cache="true"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.classification_of_accident">
                        {{ api_errors.data.classification_of_accident.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <SelectForeign
                        :model.sync="issue_obj.data.cause_of_accident"
                        label="Causes"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_causes}?issue_type_category=road_user_accident&active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="false"
                        :disabled="mode != 'e'"
                        :use_cache="true"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.cause_of_accident">
                        {{ api_errors.data.cause_of_accident.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
        </div>
        <div>
            <h5 class="ml-3">Road Details</h5>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <SelectForeign
                        :model.sync="issue_obj.data.road_feature"
                        label="Road Feature"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_road_features}?active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="false"
                        :disabled="mode != 'e'"
                        :use_cache="true"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.road_feature">
                        {{ api_errors.data.road_feature.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <SelectForeign
                        :model.sync="issue_obj.data.road_condition"
                        label="Road Condition"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_road_conditions}?active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="false"
                        :disabled="mode != 'e'"
                        :use_cache="true"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.road_condition">
                        {{ api_errors.data.road_condition.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <SelectForeign
                        :model.sync="issue_obj.data.intersection_type"
                        label="Intersection Type"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_intersection_types}?active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="false"
                        :disabled="mode != 'e'"
                        :use_cache="true"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.intersection_type">
                        {{ api_errors.data.intersection_type.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <SelectForeign
                        :model.sync="issue_obj.data.weather_condition"
                        label="Weather Condition"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_weather_conditions}?active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="false"
                        :disabled="mode != 'e'"
                        :use_cache="true"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.weather_condition">
                        {{ api_errors.data.weather_condition.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
        </div>
        <div>
            <h5 class="ml-3">Vehicle Details</h5>
            <vs-row class="mt-3">
                <vs-col>
                    <vs-table :data="issue_obj.data.accident_types" noDataText="No Accident Types" class="table-fiX">
                        <template slot="thead">
                            <vs-th style="min-width: 180px;">Type</vs-th>
                            <vs-th style="min-width: 180px;">Vehicle Type</vs-th>
                            <vs-th style="max-width: 100px;">Vehicle No</vs-th>
                            <vs-th style="max-width: 80px;">Affected Minors</vs-th>
                            <vs-th style="max-width: 80px;">Grievious</vs-th>
                            <vs-th style="max-width: 60px;">Fatal</vs-th>
                            <vs-th style="max-width: 80px;">Non Injured</vs-th>
                            <vs-th v-if="!(mode != 'e')">Action</vs-th>
                        </template>
                        <vs-tr v-for="(item, index) in issue_obj.data.accident_types" :key="index">
                            <!-- Type -->
                            <vs-td>
                                <SelectForeign
                                    :model.sync="item.accident_type"
                                    placeholder="Type to Search.."
                                    :multiple="false"
                                    :load_initial="true"
                                    :label_keys="['name', ]"
                                    :show_id_in_label="false"
                                    :endpoint="`${$store.state.apiendpoints.data_accident_type}?active=true`"
                                    container_class="w-full"
                                    input_class=""
                                    :use_id_as_value="false"
                                    :disabled="mode != 'e'"
                                    :use_cache="true"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.accident_types && 
                                    index < api_errors.data.accident_types.length && api_errors.data.accident_types[index].accident_type">
                                    {{ api_errors.data.accident_types[index].accident_type.join(', ') }}
                                </small>
                            </vs-td>
                            <!-- Vehicle Type -->
                            <vs-td>
                                <SelectForeign
                                    :model.sync="item.vehicle_responsible"
                                    placeholder="Type to Search.."
                                    :multiple="true"
                                    :load_initial="true"
                                    :label_keys="['name', ]"
                                    :show_id_in_label="false"
                                    :endpoint="`${$store.state.apiendpoints.data_vehicle_types}?issue_type_category=road_user_accident&active=true`"
                                    container_class="w-full"
                                    input_class=""
                                    :use_id_as_value="false"
                                    :disabled="mode != 'e'"
                                    :use_cache="true"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.accident_types && 
                                    index < api_errors.data.accident_types.length && api_errors.data.accident_types[index].vehicle_responsible">
                                    {{ api_errors.data.accident_types[index].vehicle_responsible.join(', ') }}
                                </small>          
                            </vs-td>
                            <!-- Vehicle No -->
                            <vs-td>
                                <vs-input
                                    class="w-full"
                                    v-model="item.vehicle_victim"
                                    :disabled="mode != 'e'"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.accident_types && 
                                    index < api_errors.data.accident_types.length && api_errors.data.accident_types[index].vehicle_victim">
                                    {{ api_errors.data.accident_types[index].vehicle_victim.join(', ') }}
                                </small>          
                            </vs-td>
                            <!-- Affected Minors -->
                            <vs-td>
                                <vs-input
                                    type="number"
                                    class="w-full"
                                    min="0"
                                    v-model="item.no_of_affected_minor"
                                    :disabled="mode != 'e'"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.accident_types && 
                                    index < api_errors.data.accident_types.length && api_errors.data.accident_types[index].no_of_affected_minor">
                                    {{ api_errors.data.accident_types[index].no_of_affected_minor.join(', ') }}
                                </small>            
                            </vs-td>
                            <!-- Grievious -->
                            <vs-td>
                                <vs-input
                                    type="number"
                                    class="w-full"
                                    min="0"
                                    v-model="item.no_of_affected_grievious"
                                    :disabled="mode != 'e'"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.accident_types && 
                                    index < api_errors.data.accident_types.length && api_errors.data.accident_types[index].no_of_affected_grievious">
                                    {{ api_errors.data.accident_types[index].no_of_affected_grievious.join(', ') }}
                                </small>            
                            </vs-td>
                            <!-- Fatal -->
                            <vs-td>
                                <vs-input
                                    type="number"
                                    class="w-full"
                                    min="0"
                                    v-model="item.no_of_affected_fatal"
                                    :disabled="mode != 'e'"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.accident_types && 
                                    index < api_errors.data.accident_types.length && api_errors.data.accident_types[index].no_of_affected_fatal">
                                    {{ api_errors.data.accident_types[index].no_of_affected_fatal.join(', ') }}
                                </small>
                            </vs-td>
                            <!-- Non Injured -->
                            <vs-td>
                                <vs-input
                                    type="number"
                                    class="w-full"
                                    min="0"
                                    v-model="item.no_of_non_injured"
                                    :disabled="mode != 'e'"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.accident_types && 
                                    index < api_errors.data.accident_types.length && api_errors.data.accident_types[index].no_of_non_injured">
                                    {{ api_errors.data.accident_types[index].no_of_non_injured.join(', ') }}
                                </small>            
                            </vs-td>
                            <vs-td v-if="!(mode != 'e')">
                                <template v-if="index == issue_obj.data.accident_types.length-1">
                                    <vs-button
                                        size="small" 
                                        class="p-1" 
                                        @click="addAccidentType"
                                        :disabled="mode != 'e'"
                                    >
                                        +
                                    </vs-button>
                                </template>
                                <vs-button
                                    v-if="issue_obj.data.accident_types.length >= 2"
                                    size="small" 
                                    color="danger" 
                                    class="p-1 mx-1"
                                    @click="issue_obj.data.accident_types.splice(index, 1)"
                                >
                                    X
                                </vs-button>
                            </vs-td>
                        </vs-tr>
                    </vs-table>
                </vs-col>
            </vs-row>
            <vs-row class="mt-3">
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <vs-input
                        type="number"
                        label="No. of Animals Killed (if any)"
                        class="w-full"
                        min="0"
                        v-model="issue_obj.data.no_of_animals_killed"
                        :disabled="mode != 'e'"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.no_of_animals_killed">
                        {{ api_errors.data.no_of_animals_killed.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
        </div>
        <div>
            <h5 class="ml-3">Other Details</h5>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <vs-input
                        label="Nearby Police Station"
                        class="w-full"
                        v-model="issue_obj.data.nearby_police_station"
                        :disabled="mode != 'e'"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.nearby_police_station">
                        {{ api_errors.data.nearby_police_station.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="mb-3">
                    <SelectForeign
                        :model.sync="issue_obj.data.help_provided_by"
                        label="Help provided by"
                        placeholder="Type to Search.."
                        :multiple="true"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_help_types}?active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="false"
                        :disabled="mode != 'e'"
                        :use_cache="true"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.help_provided_by">
                        {{ api_errors.data.help_provided_by.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <vs-input
                        type="text"
                        label="Remarks"
                        class="w-full"
                        v-model="issue_obj.data.remarks"
                        :disabled="mode != 'e'"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.remarks">
                        {{ api_errors.data.remarks.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
        </div>
        <div>
            <h5 class="ml-3">Image Details</h5>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <label class="vs-input--label block mb-1" v-if="mode == 'v'">Images</label>
                    <FileSelection
                        :images.sync="issue_obj.images"
                        :filter="val => val.image_type == undefined || val.image_type == null || val.image_type == 'p'"
                        :read_only="mode != 'e'"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.images">
                        {{ api_errors.images.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
        </div>
        <div>
            <h5 class="ml-3">Map Details</h5>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                    <LocationChooser :disabled="mode != 'e'" :latitude.sync="issue_obj.data.location_latitude" :longitude.sync="issue_obj.data.location_longitude" :api_errors="{latitude: api_errors.data ? api_errors.data.location_latitude : null, longitude: api_errors.data ? api_errors.data.location_longitude : null}" />
                </vs-col>
            </vs-row>
        </div>
        <vs-row class="mt-base" v-if="show_action_buttons && show_review && $store.state.is_online">
            <vs-col class="text-center">
                <vs-button @click="$emit('reject')" type="filled" color="primary" class="mx-2">
                    Reject
                </vs-button>
                <vs-button @click="$emit('approve')" type="filled" color="primary" class="mx-2">
                    Approve
                </vs-button>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import SelectDate  from '../../../components/letstream/ls-select-date/SelectDate.vue'
import LocationChooser from '../Components/LocationChooser.vue'
import FileSelection from "../Components/FileSelection.vue"
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
    props: {
        issue: {
            required: true,
            type: Object
        },
        api_errors: {
            required: true,
            type: Object
        },
        mode: {
            required: true,
            type: String
        },
        show_action_buttons: {
            required: true,
            type: Boolean
        },
        show_review: {
            required: true,
            type: Boolean
        },
        manager_dropdown: {
            required: true,
            type: Function
        }
    },
    components: {
        SelectDate,
        LocationChooser,
        FileSelection,
        VueTimepicker
    },
    data () {
        return {
            issue_obj: null,
            default_data: {
                date_of_accident: new Date(Date.now()),
                direction:null,
                accident_location: null,
                chainage_from: null,
                chainage_to: null,
                time_of_accident: '',
                accident_call_received_at: '',
                safety_team_reached_at: '',
                response_time: '',
                accident_clearance_time: '',
                nature_of_accident: null,
                classification_of_accident: null,
                cause_of_accident: null,
                road_feature: null,
                road_condition: null,
                intersection_type: null,
                weather_condition: null,

                accident_types: [],
                no_of_animals_killed: null,

                nearby_police_station: null,
                help_provided_by: [],

                remarks: null,
                location_latitude: null,
                location_longitude: null
            },
        }
    },
    watch: {
        issue: {
            deep: true,
            handler: function (newV) {
                this._set_by_watcher = true
                this.update_issue_obj(newV)
            }
        },
        issue_obj: {
            deep: true,
            handler: function (newV) {
                if (this._set_by_watcher) {
                    this._set_by_watcher = false
                    return
                }
                this.$emit('update:issue', newV)
            }
        },
    },
    computed: {
        response_time() {

            if (this.issue_obj.data.accident_call_received_at && this.issue_obj.data.safety_team_reached_at) {

                const a = this.issue_obj.data.accident_call_received_at.split(':').map(v => ['HH', 'mm'].includes(v) ? parseInt('00') : parseInt(v))
                const b = this.issue_obj.data.safety_team_reached_at.split(':').map(v => ['HH', 'mm'].includes(v) ? parseInt('00') : parseInt(v))

                let hour = 0
                let min = 0

                if(b[1] < a[1]) {

                    b[0]= b[0] - 1
                    min = (60 - a[1]) + b[1]
                    hour= b[0] - a[0]

                } else {

                    min  = b[1] - a[1]
                    hour = b[0] - a[0]
                }

                if (hour.toString().length === 1) {
                    hour = `0${hour}`
                } else {
                    hour = `${hour}`
                }

                if (min.toString().length === 1) {
                    min = `0${min}`
                } else {
                    min = `${min}`
                }

                this.issue_obj.data.response_time = hour + ':' + min

                return hour + ':' + min
            }

            return ''
        },
    },
    mounted() {
        this.update_issue_obj(this.issue)
    },
    methods: {
        update_issue_obj(new_data) {
            if (!new_data) this.issue_obj = null
            else {
                let issue_obj = {...new_data}
                if (!issue_obj.data) {
                    issue_obj.data = this.deepclone(this.default_data)
                    issue_obj.data.accident_types.push({
                        accident_type: null,
                        vehicle_responsible: [],
                        vehicle_victim: null,
                        no_of_affected_minor: null,
                        no_of_affected_grievious: null,
                        no_of_affected_fatal: null,
                        no_of_non_injured: null,
                    });
                }
                
                this.issue_obj = issue_obj
            }
        },
        addAccidentType() {
            this.issue_obj.data.accident_types.push({
                accident_type: null,
                vehicle_responsible: [],
                vehicle_victim: null,
                no_of_affected_minor: null,
                no_of_affected_grievious: null,
                no_of_affected_fatal: null,
                no_of_non_injured: null,
            });
        },
    }
}
</script>

<style lang="scss">
.table-fix {
    .vs-table--tbody {
        background: #fff;
        border: 0;
    }
}

.vs-table--tbody-table .tr-values:hover {
    transform:none!important;
    -webkit-transform: none!important;
}
</style>